<template>
  <section class="container mx-auto px-4 py-16">
    <div class="flex flex-col items-center text-center" v-scroll-reveal="{ delay: 0.1 }">
      <p class="text-xs uppercase tracking-[0.5em] text-amber-500">
        Signature Umrah Escapes
      </p>
      <h2 class="mt-3 text-3xl font-bold text-gray-900 md:text-4xl">
        Curated Packages for Makkah & Madina
      </h2>
      <p class="mt-4 max-w-3xl text-gray-600">
        Transparent pricing with premium hotel pairings and flexible nights. Personalize
        each itinerary with preferred airlines, additional nights, or private transport.
      </p>
    </div>

    <div class="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3 justify-items-center">
      <div
        v-for="(pkg, index) in packages"
        :key="pkg.title"
        v-scroll-reveal="{ delay: index * 0.15 }"
      >
        <PackageCard
          v-bind="pkg"
          :whatsapp-number="whatsappNumber"
        />
      </div>
    </div>

    
  </section>
</template>

<script>
import PackageCard from '../PackageCard.vue'
import luxuryQuadStayImage from '../../assets/images/madina/madina-sunset-panorama.jpg'
import executiveUmrahRetreatImage from '../../assets/images/madina/madina-rooftop-sunset.webp'
import familyComfortPackageImage from '../../assets/images/madina/madina-aerial-blue-night.jpg'

export default {
  name: 'FeaturedPackages',
  components: {
    PackageCard
  },
  data() {
    return {
      whatsappNumber: '923185073318',
      packages: [
        {
          title: 'Luxury Quad Stay',
          category: 'Signature',
          price: 155000,
          per: 'person',
          nights: '7 nights / 8 days',
          cities: '5 nights Makkah • 2 nights Madina',
          hotels: ['Makkah: Swissôtel Al Maqam (Kaaba view)', 'Madina: Anwar Al Madinah Mövenpick'],
          image: luxuryQuadStayImage
        },
        {
          title: 'Executive Umrah Retreat',
          category: 'Premium',
          price: 165000,
          per: 'person',
          nights: '10 nights / 11 days',
          cities: '6 nights Makkah • 4 nights Madina',
          hotels: ['Makkah: Jabal Omar Hyatt Regency', 'Madina: The Oberoi'],
          image: executiveUmrahRetreatImage
        },
        {
          title: 'Family Comfort Package',
          category: 'Value Plus',
          price: 145000,
          per: 'person',
          nights: '12 nights / 13 days',
          cities: '7 nights Makkah • 5 nights Madina',
          hotels: ['Makkah: Hilton Convention', 'Madina: Pullman Zamzam'],
          image: familyComfortPackageImage
        }
      ]
    }
  }
  // methods: {
  //   handleCustomize(selectedPackage) {
  //     const message = selectedPackage
  //       ? `Customize ${selectedPackage.title}`
  //       : 'Customize your Umrah journey'
  //     alert(`${message} – contact team to proceed.`)
  //   }
  // }
}
</script>

